module.exports = __webpack_public_path__ + "img/metabolism.7b37ce20.png";